import { render } from "./TableRowMenuButton.vue?vue&type=template&id=676935d4"
import script from "./TableRowMenuButton.vue?vue&type=script&lang=ts"
export * from "./TableRowMenuButton.vue?vue&type=script&lang=ts"
script.render = render

export default script